export default {
    "profile": "መገለጫ",
    "logout": "ውጣ",
    "dashboard": "ዳሽቦርድ",
    "password": "የይለፍ ቃል",
    "language": "ቋንቋ",
    "paymentbr": "ክፍያ",
    "subscriptionPaymentMethod": "የደንበኝነት ምዝገባ እና የክፍያ ዘዴ",
    "nothingchanged": "ምንም አልተለወጠም።",
    "somethingWentWrong": "የሆነ ስህተት ተከስቷል ! እባክዎ ቆይተው እንደገና ይሞክሩ",
    "pleaseTryAgainAfterSometime": "እባክዎ ከተወሰነ ጊዜ በኋላ እንደገና ይሞክሩ",
    "noChanges": "አልተለወጠም።",
    "invalidEmailFormat": "የኢሜል ቅርጸቱ ልክ ያልሆነ ነው።",
    "chooseYourPreferredLanguage": "እባክዎ የመረጡትን ቋንቋ ይምረጡ።",
    "selectLanguage": "ቋንቋ ይምረጡ",
    "update": "አዘምን",
    "languagePreferences": "የቋንቋ ምርጫዎች",
    "packageOf": "ጥቅል የ",
    "satelliteReport": "የሳተላይት ዘገባዎች",
    "pastureReport": "የግጦሽ ሪፖርቶች",
    "upTo": "እስከ",
    "animals": "እንስሳት",
    "back": "ተመለስ",
    "perMonth": "በ ወር",
    "perYear": "በዓመት",
    "continue": "ቀጥል",
    "changePlan": "እቅድ ቀይር",
    "addOn": "መደመር",
    "totalPrice": "ጠቅላላ ዋጋ",
    "availableAddOns": "የሚገኙ ተጨማሪዎች",
    "next": "ቀጥሎ",
    "congratulations": "እንኳን ደስ አላችሁ",
    "done": "ተከናውኗል",
    "deforestationComplianceAssessment": "የደን ​​ጭፍጨፋ ተገዢነት ግምገማዎች",
    "warning": "ማስጠንቀቂያ",
    "yourDataMightLost": "የእርስዎ ውሂብ ሊጠፋ ይችላል።",
    "clickOnSaveBtnMsg": "ውሂብዎን ለማቆየት አስቀምጥ ቁልፍን ጠቅ ያድርጉ",
    "discardChanges": "ለውጦችን አስወግድ",
    "action": "ድርጊቶች",
    "sendRequest": "ጥያቄ ላክ",
    "success": "ስኬት",
    "yourRequestSuccessfullySubmitted": "ጥያቄዎ በተሳካ ሁኔታ ገብቷል።",
    "informShortly": "ጥያቄዎ በተሳካ ሁኔታ ገብቷል። የትንታኔ ዘገባዎ በቅርቡ ይላክልዎታል።",
    "search": "ፈልግ",
    "pending": "በመጠባበቅ ላይ",
    "approved": "ጸድቋል",
    "rejected": "ውድቅ ተደርጓል",
    "primaryGeofence": "ዋና ጂኦፊንስ",
    "Zero/Negligible Deforestation Probability": "አነስተኛ ወይም ያልተገመተ የትራስ አጥፋት እንክብካቤ",
    "Low Deforestation Probability": "ዝቅተኛ የትራስ አጥፋት እንክብካቤ",
    "High Deforestation Probability": "ከፍተኛ የትራስ አጥፋት እንክብካቤ",
    
    "login": {
        "welcome": "እንኳን ደህና መጣህ! ግባ",
        "welInfo": "ምስክርነቶችዎን ያስገቡ።",
        "login": "ግባ",
        "emailMobile": "ኢሜል/ሞባይል",
        "forgotPassword": "መክፈቻ ቁልፉን ረሳኽው",
        "register": "ይመዝገቡ",
        "unableToLogin": "መግባት አልተቻለም",
        "emailMobileCannotEmpty": "ኢሜል/ሞባይል ባዶ ሊሆን አይችልም።",
        "invalidEmailMobileFormat": "ልክ ያልሆነ የኢሜይል/ሞባይል ቅርጸት።",
        "passwordCannotEmpty": "የይለፍ ቃል ባዶ ሊሆን አይችልም።",
        "passwordLengthCanlessthan8": "የይለፍ ቃል ርዝመት ከ 8 ቁምፊዎች ያነሰ ሊሆን አይችልም.",
        "email": "ኢሜይል",
        "phone": "ስልክ",
        "or": "ወይም",
        "alreadyHaveAccount": "መለያ አለህ",
        "loginNow": "አሁን ግባ",
        "registerOption": "ለመመዝገብ አንድ አማራጭ ይምረጡ",
        "signUpWith": "በ ይመዝገቡ"
    },
    "user": {
        "profileUpdated": "መገለጫ በተሳካ ሁኔታ ዘምኗል",
        "profileNotUpdated": "መገለጫ አልተዘመነም።",
        "otpSentOnEmail": "OTP በተሳካ ሁኔታ ተልኳል!",
        "otpSentSuccessFully": "የእርስዎ OTP ኮድ ተልኳል።",
        "unableToVerifyEmail": "ኢሜይሉን ማረጋገጥ አልተቻለም",
        "emailCanNotBeEmpty": "የኢሜል መስኮች ባዶ ሊሆኑ አይችሉም",
        "firstName": "የመጀመሪያ ስም",
        "lastName": "የአያት ስም",
        "email": "ኢሜይል",
        "mobile": "ሞባይል",
        "currentPassword": "የአሁኑ ሚስጥራዊ ማለፊያ ቁልፍ",
        "newPassword": "አዲስ የይለፍ ቃል",
        "repeatNewPassword": "አዲስ የይለፍ ቃል ድገም",
        "firstNameRequired": "የመጀመሪያ ስም ያስፈልጋል።",
        "lastNameRequired": "የአያት ስም ያስፈልጋል",
        "emailRequired": "ኢሜል ያስፈልጋል",
        "onlyAlphabet": "ፊደላትን ብቻ መያዝ ይችላል።",
        "notMoreThan15Char": "ከ15 ቁምፊዎች በላይ መሆን አይችልም።",
        "phoneCannotLessThan8Char": "ስልኩ ከ 8 ቻር በታች መሆን አይችልም።",
        "countryCodeRequire": "የአገር ኮድ ያስፈልጋል",
        "changePassword": "የሚስጥር ቁልፍ ይቀይሩ",
        "goodIdeaToUsePassword": "ሌላ ቦታ የማይጠቀሙትን ጠንካራ የይለፍ ቃል መጠቀም ጥሩ ሀሳብ ነው።",
        "enterCurrentPassword": "የአሁኑን የይለፍ ቃል ያስገቡ",
        "enterNewPassword": "አዲስ የይለፍ ቃል ያስገቡ",
        "reEnterPassword": "ሚስጥራዊ ቃል እንደገና አስገባ",
        "pleaseTypeOldPassword": "እባክህ የድሮ የይለፍ ቃል ጻፍ።",
        "pleaseTypeNewPassword": "እባክዎ አዲስ የይለፍ ቃል ይተይቡ።",
        "pleaseTypeConfirmPassword": "እባክህ አረጋግጥ የይለፍ ቃል ጻፍ።",
        "passwordChangedSuccesFully": "የይለፍ ቃል በተሳካ ሁኔታ ተቀይሯል።",
        "passwordDoesNotMatch": "የይለፍ ቃሎች አይዛመዱም።",
        "passwordRequired": "የይለፍ ቃል ያስፈልጋል",
        "emailOrPhoneIsRequired": "ኢሜል ወይም ስልክ ቁጥር ያስፈልጋል"
    },
    "subscription": {
        "subscription": "የደንበኝነት ምዝገባ",
        "membershipPlan": "የአባልነት ዕቅዶች",
        "currentMembershipPlan": "የአሁኑ የአባልነት እቅድ",
        "validUpTo": "የሚሰራ እስከ",
        "viewAllAddOns": "ሁሉንም ተጨማሪዎች ይመልከቱ",
        "renewValidity": "ትክክለኛነትን ያድሱ",
        "buyNow": "አሁን ግዛ",
        "upgradeMembershipPlan": "የአባልነት እቅድ አሻሽል።",
        "chooseYourMembershipPlan": "የመረጡት የአባልነት እቅድ",
        "chooseOptionalAddOns": "አማራጭ ማከያዎች መምረጥ ይችላሉ።",
        "yourSelectedAddons": "የእርስዎ የተመረጡ ተጨማሪዎች",
        "addAnotherAddOn": "ሌላ ተጨማሪ ያክሉ",
        "paymentMethod": "የመክፈያ ዘዴ",
        "addingAPaymentMethod": "የመክፈያ ዘዴ ማከል",
        "paymentSuccessful": "ክፍያዎ ተሳክቷል!",
        "weHaveEmailed": "የደረሰኝዎን ቅጂ ወደ example@email.com ልከናል።",
        "paymentAuthorizedSuccessfully": "ክፍያ በተሳካ ሁኔታ ተፈቅዷል።",
        "paymentSuccessfulPrompt": "ክፍያ ተሳክቷል። እቅድ ተሻሽሏል።",
        "paymentCancelled": "ክፍያ ተሰርዟል። እባክዎ ዳግም ይሞክሩ."
    },
    "registerFarm": "እርሻ ይመዝገቡ",
    "requestDeforestationReport": "የደን ​​ጭፍጨፋ ሪፖርት ይጠይቁ",
    "paymentMenu": "ክፍያ",
    "complianceCertificate": "ተገዢነት የምስክር ወረቀት",
    "helpDisk": "የእገዛ ዲስክ",
    "faqs": "የሚጠየቁ ጥያቄዎች",
    "enquiries": "ጥያቄዎች",
    "contactUs": "አግኙን",
    "payment": {
        "basicPlan": "መሰረታዊ እቅድ",
        "advancePlan": "የቅድሚያ እቅድ",
        "usdPerMonthPlus": "ዶላር በወር ሲደመር",
        "perReport": "በሪፖርት",
        "deforestationAnalyticsCertificateDownload": "የደን ​​ጭፍጨፋ ትንታኔ የምስክር ወረቀት ማውረድ"
    },
    "farm": {
        "farmOwnershipType": "የእርሻ ባለቤትነት አይነት",
        "licenceNum": "የፍቃድ ቁጥር",
        "viewFarm": "እርሻን ይመልከቱ",
        "stateProvince": "ግዛት/ግዛት።",
        "postalNumberShouldSimilarToFarm": "ከቤት ቁጥር ጋር የሚመሳሰል የእርሻ የፖስታ ቁጥር።",
        "videoTutorial": "የቪዲዮ አጋዥ ስልጠና",
        "clickOnMapMSG": "geofencing ለመጀመር ካርታው ላይ ጠቅ ያድርጉ",
        "prev": "ቀዳሚ",
        "next": "ቀጥሎ",
        "dragVertexMsg": "እንዲሁም ጠርዙን መጎተት ወይም በቀኝ በኩል ያለውን የሰርዝ ቁልፍ በመጠቀም መሰረዝ ይችላሉ። የጂኦፊንስ አዝራሩን በመጠቀም ማጽዳት ይቻላል",
        "farmAddedSuccessfully": "እርሻ በተሳካ ሁኔታ ታክሏል።",
        "perimeter": "ፔሪሜትር",
        "area": "አካባቢ",
        "clearGeofence": "Geofence አጽዳ",
        "deleteSelectedVertex": "የተመረጠውን Vertex ሰርዝ",
        "pleaseStartDrawing": "እባክዎ በካርታው ላይ የጂኦግራፊያዊ አጥርን መሳል ይጀምሩ።",
        "chooseTheDate": "ቀኑን ይምረጡ",
        "updateGeofenceForThisFarm": "ለዚህ እርሻ GEOFENCE አዘምን",
        "farmUpdateSuccessfully": "እርሻ በተሳካ ሁኔታ ዘምኗል",
        "farmZone": "የእርሻ ዞኖች",
        "addNewZones": "አዲስ ዞኖችን ያክሉ",
        "zoneName": "የዞን ስም",
        "addZoneToCreate": "ለዚህ እርሻ ዞን ለመፍጠር እባክዎን ዞኖችን ያክሉ ላይ ጠቅ ያድርጉ።",
        "noZoneCreated": "እስካሁን ምንም ዞኖች አልተፈጠሩም።",
        "searchAndAddPin": "ፈልግ እና ፒን ጨምር",
        "zoneNameWillBeHere": "የዞኑ ስም እዚህ ይሆናል።",
        "editZone": "ዞን አርትዕ",
        "nameOfTheField": "የመስክ ስም",
        "zoneDetails": "የዞን ዝርዝሮች",
        "addZone": "ዞን አክል",
        "nameOfTheZone": "የዞኑ ስም",
        "geofenceIsRequiredToAdd": "ዞን ለመጨመር ጂኦፊንስ ያስፈልጋል። የጂኦፌንስ ዝርዝሮችን ወደ እርሻዎ ለማከል «እርሻን አርትዕ»ን ጠቅ ያድርጉ።",
        "thisFieldApplyHelpText": "ይህ መስክ እርስዎን የሚመለከተው የየትኛውም የህብረት ስራ ማህበር አባል ከሆኑ ብቻ ነው (የህብረት ስራ ማህበር ራሱን የቻለ የሰዎች ማህበር በፈቃደኝነት የጋራ ኢኮኖሚያዊ፣ማህበራዊ እና ባህላዊ ፍላጎቶቻቸውን እና ምኞቶቻቸውን በጋራ በባለቤትነት እና በዲሞክራሲያዊ ቁጥጥር ስር ባለው ኢንተርፕራይዝ በኩል) ለማሟላት ነው። የኅብረት ሥራ ማኅበር አባል ከሆኑ፣ እባኮትን የኅብረት ሥራ ማኅበሩን ልዩ መለያ ያመልክቱ፣ የምዝገባ ወይም የፈቃድ ቁጥር ሊሆን ይችላል፣ የሚገናኙትን የኅብረት ሥራ ማኅበር የሚለይ።",
        "farmRegistrationID": "የእርሻ ምዝገባ መታወቂያ",
        "farmerName": "የገበሬ ስም",
        "farmerRegistrationID": "የገበሬዎች ምዝገባ መታወቂያ",
        "dateOfRequest": "የጥያቄ ቀን",
        "status": "ሁኔታ",
        "address": "አድራሻ",
        "save": "አስቀምጥ",
        "farmAddress": "የእርሻ ቦታ አድራሻ",
        "corporateName": "የድርጅት ስም",
        "corporateMailingAddress": "የድርጅት የፖስታ አድራሻ",
        "farmID": "የእርሻ መታወቂያ",
        "onTheFarm": "በእርሻ ላይ",
        "userRoles": "የተጠቃሚ ሚናዎች",
        "adduser": "ተጠቃሚ አክል",
        "addAuser": "ተጠቃሚ ያክሉ",
        "uploadUsers": "ተጠቃሚዎችን ጫን",
        "addNewUser": "አዲስ ተጠቃሚ ያክሉ",
        "selectDept": "ክፍል ይምረጡ",
        "selectRole": "ሚና ይምረጡ",
        "editUser": "ተጠቃሚን ያርትዑ",
        "totalFarms": "ጠቅላላ እርሻዎች",
        "NoAnimalsRegisteredForthisFarm": "ለዚህ እርሻ ምንም እንስሳት አልተመዘገቡም።",
        "farmsPerPage": "እርሻዎች በገጽ",
        "regularFarms": "መደበኛ እርሻዎች",
        "farmRegisteredProducts": "በእርሻ የተመዘገቡ ምርቶች",
        "searchByFarmNameAndId": "በእርሻ ስም እና መታወቂያ ይፈልጉ",
        "loadingProductsPleaseWait": "ምርቶችን በመጫን ላይ... እባክዎ ይጠብቁ",
        "farmName": "የእርሻ ስም",
        "farmLocation": "የእርሻ ቦታ",
        "productName": "የምርት ስም",
        "stockStatus": "የአክሲዮን ሁኔታ",
        "inStock": "ለሽያጭ የቀረበ እቃ",
        "searchByProductName": "በምርት ስም ይፈልጉ",
        "productCategory": "የምርት ምድብ",
        "products": "ምርቶች",
        "yourLocationIsDisabled": "አካባቢህ ተሰናክሏል። እባክዎ አካባቢዎን ከግራ ምናሌዎች ይፈልጉ።",
        "close": "ገጠመ",
        "farms": "እርሻዎች",
        "zones": "ዞኖች",
        "registerAfarm": "እርሻ ይመዝገቡ",
        "govtRegistry": "መንግስት መዝገብ ቤት",
        "cooperativeID": "የትብብር/የማህበር መታወቂያ",
        "cooperativeName": "የህብረት/የህብረት ስም",
        "farmType": "የእርሻ ዓይነት",
        "contractMating": "ኮንትራት ማዛመድ",
        "customization": "ማበጀት",
        "recordsPerpage": "መዝገቦች በገጽ",
        "restoreDefault": "ነባሪ እነበረበት መልስ",
        "apply": "ያመልክቱ",
        "CommunityName": "የማህበረሰብ ስም",
        "searchState": "በእርሻ መታወቂያ፣ በመንግስት መዝገብ ቤት፣ በመተባበር መታወቂያ፣ የእርሻ ዓይነት፣ የኮንትራት ማዛመድን ይፈልጉ",
        "farmOwner": "የእርሻ ባለቤት",
        "govRegistrationNo": "የመንግስት ምዝገባ ቁጥር",
        "farmInformation": "የእርሻ መረጃ",
        "ownershipType": "የባለቤትነት አይነት",
        "farmLicenseInformation": "የእርሻ ፈቃድ መረጃ",
        "licenseNumber": "የፍቃድ ቁጥር",
        "licenseExpiryDate": "የፍቃድ ጊዜው የሚያበቃበት ቀን",
        "regulatorName": "የቁጥጥር ስም",
        "regulatorRepresentativeName": "ተቆጣጣሪ ተወካይ ስም",
        "farmLocationSize": "የእርሻ ቦታ እና መጠን",
        "productionSystem": "የእርሻ ስርዓት",
        "country": "ሀገር",
        "state": "ግዛት",
        "city": "መንደር / ከተማ / ከተማ",
        "farmNumber": "የእርሻ ቁጥር",
        "postal": "ፖስታ / ዚፕ ኮድ",
        "houseNumber": "የቤት ቁጥር",
        "farmRegistration": "የእርሻ ምዝገባ",
        "cancel": "ሰርዝ",
        "register": "ይመዝገቡ",
        "ok": "እሺ",
        "totalFarmSize": "ጠቅላላ የእርሻ መጠን",
        "geographicLocation": "ጂኦግራፊያዊ አካባቢ",
        "farmGeographicLocation": "የእርሻ ጂኦግራፊያዊ አካባቢ",
        "perimeterPointLongitude": "የፔሪሜትር ነጥብ ኬንትሮስ",
        "perimeterPointLatitude": "የፔሪሜትር ነጥብ ኬክሮስ",
        "perimeterPointLabel": "የፔሪሜትር ነጥብ መለያ",
        "perimeterLength": "የፔሪሜትር ርዝመት",
        "farmLatitude": "የእርሻ ኬክሮስ",
        "farmLongitude": "የእርሻ ኬንትሮስ",
        "latitude": "ኬክሮስ",
        "longitude": "ኬንትሮስ",
        "areaUnit": "የአካባቢ ክፍል",
        "walkAndMeasure": "ይራመዱ እና ይለኩ",
        "useGeofenceTool": "የጂኦፌንሱን መሳሪያ ተጠቀም",
        "editFarm": "እርሻ አርትዕ",
        "update": "አዘምን",
        "editAfarm": "አንድ እርሻ አርትዕ",
        "nextFarm": "ቀጣይ እርሻ",
        "nameoftheFarm": "የእርሻው ስም",
        "registerAProduct": " አንድ ምርት ይመዝገቡ",
        "farmProducts": "የእርሻ ምርቶች",
        "calf": "ጥጃ",
        "steer": "መምራት",
        "heifer": "ጊደር",
        "sire": "ሳይሬ",
        "dam": "ግድብ",
        "registerAnAnimal": "አንድ እንስሳ ይመዝገቡ",
        "farmAnimals": "የእርሻ እንስሳት",
        "farm_type": "የእርሻ ዓይነት",
        "farm_Owner": "የእርሻ-ባለቤት",
        "dateOfRegistration": "የምዝገባ ቀን",
        "dataIsNotAvailableForThisFarm": "ውሂብ ለዚህ እርሻ አይገኝም",
        "registerNewProduct": "አዲስ ምርት ይመዝገቡ",
        "information": "መረጃ",
        "licenseInfo": "የፍቃድ መረጃ",
        "locationInfo": "የአካባቢ መረጃ",
        "geoLocation": "ጂኦ አካባቢ",
        "perimeterLengthState": "የእርሻ ፔሪሜትር ርዝመት (የአጥር ርዝመት)",
        "totalFarmSizeState": "የእርሻ መጠን",
        "productionSystemState": "በእርሻ ውስጥ ጥቅም ላይ የዋለው የምርት ስርዓት",
        "contractMatingState": "እርሻው የሚሳተፍበት የኮንትራት ማዛመጃ ፕሮግራም ኮድ.",
        "ownershipTypeState": "የባለቤትነት አይነት",
        "regulatorRepresentativeNameState": "ፈቃዱን ያወጣው ተቆጣጣሪን የሚወክል ሰው ስም",
        "regulatorNameState": "ፈቃዱን የለቀቀው የቁጥጥር ስም",
        "licenseExpiryDateState": "የአሁኑ ፈቃድ ጊዜው የሚያበቃበት ቀን",
        "licenseNumberState": "የፍቃድ ቁጥር በአስተዳዳሪ ተለቋል",
        "plotNumberState": "የእርሻው የቤት ቁጥር.",
        "plotNumber": "የእርሻ ቁጥር",
        "streetStatement": "የእርሻው የመንገድ ስም.",
        "cityStatement": "እርሻው የሚገኝበት ከተማ።",
        "stateStatement": "እርሻው የሚገኝበት የአገሪቱ ክልል.",
        "countryState": "እርሻው የሚገኝበት አገር.",
        "farmStateInfo": "የእርሻ ቦታ አድራሻ",
        "perimeterPointLongitudeState": "በእርሻ ላይ የአንድ ነጥብ ኬንትሮስ.",
        "perimeterPointLatitudeState": "በእርሻ ላይ የአንድ ነጥብ ኬክሮስ።",
        "perimeterPointLabelState": "የነጥብ መለያ።",
        "farmLongitudeState": "የእርሻው ኬንትሮስ.",
        "farmLatitudeState": "የእርሻው ኬክሮስ.",
        "deleteFarm": "እርሻን ሰርዝ",
        "corporateRegistrationNum": "የድርጅት ምዝገባ ቁጥር",
        "farmLocationIsRequired": "የእርሻ ቦታ ያስፈልጋል."
    },
    "deforestation": {
        "addZoneToThisFarm": "ወደዚህ እርሻ ዞኖችን ያክሉ",
        "eudrForestAssessment": "EUDR የደን ግምገማዎች",
        "requestEudrForestAssessment": "EUDR የደን ግምገማን ይጠይቁ",
        "pleaseChooseOption": "እባክዎ አማራጭ ይምረጡ",
        "requestForestReport": "የደን ​​ሪፖርት ይጠይቁ",
        "noDeforestationReportMsg": "የደን ​​ጭፍጨፋ ሪፖርት አልተጠየቀም። እዚህ እንዲዘረዘሩ አንዳንድ የደን ጭፍጨፋ ሪፖርቶችን ይጠይቁ።",
        "allCountries": "ሁሉም አገሮች",
        "allRegions": "ሁሉም ክልሎች",
        "allFarms": "ሁሉም እርሻዎች",
        "allStatus": "ሁሉም ሁኔታ",
        "viewCertificate": "የምስክር ወረቀት ይመልከቱ",
        "requestComplianceCertificate": "የተገዢነት ሰርተፍኬት ጠይቅ",
        "assessmentNo": "ግምገማ ቁጥር",
        "blockchainCertificationInfo": "የብሎክቼይን የምስክር ወረቀት ማረጋገጫ ሃሽ የምስክር ወረቀት ሲቀበል ይገኛል",
        "blockchainCertificationValidation": "የብሎክቼይን የምስክር ወረቀት ማረጋገጫ",
        "openBlockchainPage": "የብሎክቼይን ገጽ ክፈት",
        "clickOnAboveLink": "በብሎክቼይን ላይ የምስክር ወረቀት ለማረጋገጥ ከላይ ያለውን አገናኝ ጠቅ ያድርጉ",
        "shareCertificate": "የምስክር ወረቀት አጋራ",
        "high": "ከፍተኛ",
        "low": "ዝቅተኛ",
        "zeroOrNegigible": "ዜሮ ወይም ግምታዊ",
        "deforestationProbability": "የደን ​​መጨፍጨፍ ዕድል",
        "colorCode": "የቀለም ኮድ",
        "geofenceAarea": "የጂኦፊንስ አካባቢ",
        "percentageOfGeofenceArea": "የጂኦፊንስ አካባቢ መቶኛ",
        "overallDeforestationProbability": "አጠቃላይ የደን ጭፍጨፋ እድል",
        "deforestationComplianceReport": "የደን ​​ጭፍጨፋ ተገዢነት ሪፖርቶች",
        "noDeforestationComplianceReport": "የደን ​​ጭፍጨፋ ተገዢ የሆነ ኢ-ሪፖርት አልተገኘም።",
        "loadingDeforestationComplianceReport": "የደን ​​ጭፍጨፋ ተከባሪ ኢ-ሪፖርትን በመጫን ላይ",
        "farmRegistrationId": "የእርሻ ምዝገባ መታወቂያ",
        "farmerName": "የገበሬ ስም",
        "farmerRegistrationId": "የገበሬዎች ምዝገባ መታወቂያ",
        "uniqueFarmerId": "ልዩ የገበሬ መታወቂያ",
        "uniqueFarmId": "ልዩ የእርሻ መታወቂያ",
        "farmLocation": "የእርሻ ቦታ",
        "area": "አካባቢ",
        "farmAddress": "የእርሻ አድራሻ",
        "dateOfRequest": "የጥያቄ ቀን",
        "status": "ሁኔታ",
        "settings": "ቅንብሮች",
        "assignmentIssued": "ምደባ ተሰጥቷል።",
        "certificateIssued": "የምስክር ወረቀት ተሰጥቷል።",
        "complianceCertification": "ተገዢነት ማረጋገጫ",
        "noComplianceCertification": "ምንም የተገዢነት ማረጋገጫ አልተገኘም።",
        "loadingComplianceCertification": "ተገዢነት ማረጋገጫ በመጫን ላይ",
        "assessmentReport": "የግምገማ ሪፖርት",
        "downloadPDF": "ፒዲኤፍ አውርድ",
        "print": "አትም",
        "back": "ተመለስ",
        "farmDetails": "የእርሻ ዝርዝሮች",
        "dimitraFarmId": "ዲሚትራ የእርሻ መታወቂያ",
        "dimitraFermerId": "ዲሚትራ የገበሬ መታወቂያ",
        "totalGeofenceAreaHA": "ጠቅላላ የጂኦፌንስ አካባቢ (HA)",
        "forestLossHA": "የደን ​​መጥፋት (HA)",
        "forestGainHA": "የደን ​​መጨመር (HA)",
        "forestUnchangedHA": "ጫካ ያልተለወጠ (HA)",
        "forestUnchanged": "ጫካ አልተለወጠም",
        "forestLoss": "የደን ​​መጥፋት",
        "forestGain": "የደን ​​መጨመር",
        "totalGeofenceArea": "አጠቃላይ የጂኦፌንስ አካባቢ",
        "forestAssessmentHelp": "ስለዚህ ሪፖርት ጥያቄዎች ካሉዎት ወይም እሱን ለመረዳት እገዛ ከፈለጉ፣ በእገዛ ዴስክ በኩል ያግኙን።",
        "allReport": "ሁሉም ሪፖርቶች",
        "deforestationRepot": "የደን ​​መጨፍጨፍ ሪፖርቶች",
        "requestDeforestationReportNow": "አሁን የደን ጭፍጨፋ ሪፖርት ጠይቅ",
        "noRecordFound": "ምንም መዝገብ አልተገኘም።",
        "noDeforestationReportRequested": "የደን ​​ጭፍጨፋ ሪፖርት አልተጠየቀም። እዚህ እንዲዘረዘሩ አንዳንድ የደን ጭፍጨፋ ሪፖርቶችን ይጠይቁ።",
        "deforestationImage": "የደን ​​ጭፍጨፋ ምስል",
        "reqDeforestationReport": "የደን ​​ጭፍጨፋ ሪፖርት ይጠይቁ",
        "confirm": "አረጋግጥ",
        "newForestArea": "አዲስ የደን አካባቢ",
        "deforestedArea": "የተራቆተ አካባቢ",
        "existingForestArea": "ነባር የደን አካባቢ",
        "deforestation": "የደን ​​ጭፍጨፋ",
        "farmName": "የእርሻ ስም",
        "location": "አካባቢ",
        "dateOfInterest": "የፍላጎት ቀን",
        "geofenceArea": "የጂኦፊንስ አካባቢ (ኤኤ)",
        "deforestationArea": "የደን ​​ጭፍጨፋ አካባቢ (HA)",
        "treeGainArea": "የዛፍ መገኛ ቦታ (HA)",
        "currentForestArea": "የአሁኑ የደን አካባቢ (HA)",
        "view": "ይመልከቱ",
        "locationInfoRequired": "የአካባቢ መረጃ ያስፈልጋል",
        "geofenceNameRequired": "የጂኦፊንስ ስም ያስፈልጋል",
        "futureDateSelected": "የወደፊት ቀን ተመርጧል",
        "reportGeneratedSuccessfully": "ሪፖርት በተሳካ ሁኔታ ተፈጥሯል።",
        "reportCannotAdded": "ሪፖርት ሊታከል አይችልም።",
        "primaryFarmNotFound": "የመጀመሪያ ደረጃ እርሻ አልተገኘም።",
        "pleaseRegisterFarmFirst": "እባክዎ መጀመሪያ እርሻ ይመዝገቡ"
    },
    "certificate": {
        "allCertificate": "ሁሉም የምስክር ወረቀቶች",
        "certificate": "የምስክር ወረቀት"
    }
}